export default "__VITE_ASSET__Bqv6AAdD__"